import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { setSelectedPolicyNumber } from '@verzekeringapp-mono/shared/src/state/slices/policies_slice'
import { determinePolicyDistinctionLabel } from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import { getProductIcons } from '@verzekeringapp-mono/shared/src/state/selectors/policies'

interface IProps {
  productName: IPolicy['productName']
  details: IPolicy['details']
  productId: IPolicy['productId']
  id: IPolicy['id']
  policyNumber: IPolicy['policyNumber']
  status: IPolicy['status']
}

const PolicyCard = ({
  productName,
  details,
  productId,
  id,
  policyNumber,
  status
}: IProps) => {
  const dispatch = useAppDispatch()
  const productIcons = useAppSelector(getProductIcons)

  return (
    <Link
      key={id}
      className='mb-4 flex flex-1 cursor-pointer rounded-md border border-border-default p-4'
      to={'/schade-melden/schadeformulier'}
      onClick={() => {
        dispatch(setSelectedPolicyNumber(policyNumber))
      }}
    >
      <div className='flex items-center justify-between flex-1'>
        <div className='flex flex-row gap-4 items-center'>
          <div className='flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle'>
            <FontAwesomeIcon
              icon={productIcons[productId]}
              size='lg'
              className='text-icon-brand'
            />
          </div>

          <div className='flex flex-col'>
            <p className='font-medium text-text-primary'>{`${productName}${status === 'Geroyeerd' ? ' (beëindigd)' : ''}`}</p>

            <small className='text-text-secondary'>
              {determinePolicyDistinctionLabel({
                details,
                productId,
                policyNumber
              })}
            </small>
          </div>
        </div>

        <div>
          <FontAwesomeIcon
            icon={['fal', 'chevron-right']}
            size='lg'
            className='text-icon-secondary'
          />
        </div>
      </div>
    </Link>
  )
}

export default PolicyCard
